import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';
import DsModal from '../../ds/molecules/DsModal';
import PictureSlider from '../rooms/PictureSlider';
import { getLangValue } from '../../../utils/Generic';

class InfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getResetState();
  }

  getResetState() {
    return {
      showInfoModal: false,
    };
  }

  setDefaultState() {
    // NOTE Reset all the state but keep the modal shown with the same URL
    this.setState({ ...this.getResetState(), showInfoModal: true });
  }

  openInfoModal() {
    if (!this.state.showInfoModal) {
      this.setState({ showInfoModal: true });
    }
  }

  onInfoModalClose() {
    this.setState(this.getResetState());
  }

  getExtraName(extra) {
    const extraName = getLangValue(extra, this.props.lang, 'title');
    return extraName.toLowerCase();
  }

  renderExtraDuration(duration) {
    if (duration > 0) {
      return (
        <div>
          {duration} {this.context.t('hrs')}
        </div>
      );
    }
    return null;
  }

  renderExtraTitle(extra) {
    const { currency } = this.props;
    const currentAmount = extra.prices && extra.prices[currency.code].amount;
    return (
      <div className="extra-info-modal flex justify-between font-bold">
        <div className="extra-info-modal__title text-capitalize">
          {this.getExtraName(extra)}
          {this.renderExtraDuration(extra.duration)}
        </div>
        <span className="amount-price__currency">
          {extra.prices && formatCurrency(currentAmount, currency)}
        </span>
      </div>
    );
  }

  StringList(strings) {
    return (
      <div>
        {strings.map((string, index) => (
          <div key={index}>{string}</div>
        ))}
      </div>
    );
  }

  renderOpeningHours(extra) {
    const listItems = extra.opening_hours.map((opening_hour, index) =>
      <span key={index}>
        {getLangValue(opening_hour, this.props.lang, 'opening_hour')}
      </span>);

    return (
      <div className="extra-info-modal mt-2 text-sm">
        <span className="flex pt-2 pb-1" style={{ color: '#3A608B' }}>
          {extra.opening_hours.length > 0 && this.context.t('Opening Hours')}
        </span>
        {this.StringList(listItems)}
        <br/>
      </div>
    );
  }

  renderContactPhones(extra) {
    const phones = extra.contact_phones.map((item) => item.phone);
    const formattedPhones = phones.map((phone, index) => (
            <React.Fragment key={index}>
                <a href={`tel:+${phone}`} style={{
                  color: 'blue',
                  cursor: 'pointer',
                  'text-decoration': 'underline',
                }}>{phone}</a>
                {index < phones.length - 1 && ', '}
            </React.Fragment>
    ));
    if (phones.length === 0) {
      return null;
    }
    return (
        <div className="extra-info-modal text-sm">
            {this.context.t('For bookings or more information dial ')}{formattedPhones}<br/>
        </div>
    );
  }

  renderContactEmails(extra) {
    const emails = extra.contact_emails.map((item) => item.email);
    const formattedEmails = emails.map((email, index) => (
            <React.Fragment key={index}>
                <a href={`mailto:${email}`} style={{
                  color: 'blue',
                  cursor: 'pointer',
                  'text-decoration': 'underline',
                }}>{email}</a>
                {index < emails.length - 1 && ', '}
            </React.Fragment>
    ));
    if (emails.length === 0) {
      return null;
    }
    return (
        <div className="extra-info-modal text-sm">
            {this.context.t('or contact: ')}{formattedEmails}<br/>
        </div>
    );
  }

  renderExtraContent(extra) {
    return (
      <React.Fragment>
        <div className="extra-info-modal mt-3 text-sm">
          {getLangValue(extra, this.props.lang, 'description')}
          {this.renderOpeningHours(extra)}
          {this.renderContactPhones(extra)}
          {this.renderContactEmails(extra)}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { showInfoModal } = this.state;
    return (
      <React.Fragment>
        <div className='extra-card modal-card'>
          {showInfoModal && <DsModal onClose={() => this.onInfoModalClose()}>
            <section className="p-4 relative">
              <PictureSlider photos={this.props.extra.photos} imageSize="sm" />
              <div className="flex justify-between -mx-2 mt-3">
                <div className="extra-card__content flex-col">
                  <div className="card-content flex-col">
                    {this.renderExtraTitle(this.props.extra)}
                    {this.renderExtraContent(this.props.extra)}
                  </div>
                </div>
              </div>
            </section>
          </DsModal>}
        </div>
      </React.Fragment>
    );
  }
}

InfoModal.propTypes = {
  extra: PropTypes.object,
  length: PropTypes.object,
};

InfoModal.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default InfoModal;
